module.exports = __webpack_public_path__ + "static/media/18ECA37.da872213.jpg";